import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import {
    FundedDeal,
    FundedDealsFilterOptions,
    FundedDealsFilters
} from "../models/funded-deals-portal.model";
import { Page, PageableParams } from "../models/pagination.model";
import { buildHttpParams } from "../utils/http-params";

@Injectable({ providedIn: 'root' })
export class FundedDealsPortalEndpoint {
    private readonly http = inject(HttpClient);

    private readonly endpoints = {
        fundedDeals: 'funded-deals',
        filterOptions: 'funded-deals/filter-options'
    };

    getFundedDeals(filters?: FundedDealsFilters, params?: PageableParams): Observable<Page<FundedDeal>> {
        return this.http.get<Page<FundedDeal>>(this.endpoints.fundedDeals, {
            params: buildHttpParams({ ...filters, ...params })
        });
    }

    getFilterOptions(): Observable<FundedDealsFilterOptions> {
        return this.http.get<FundedDealsFilterOptions>(this.endpoints.filterOptions);
    }
}
